export const incidentInvolvedPersonFormRules = {
  firstName: [{ required: true, message: 'First name is required!' }],
  lastName: [{ required: true, message: 'Last name is required!' }],
  phoneNumber: [{ required: true, message: 'Phone number is required!' }],
  streetName: [{ required: true, message: 'Street name is required!' }],
  streetNumber: [{ required: true, message: 'House number is required!' }],
  involvementType: [{ required: true, message: 'Involvement type is required!' }],
};
